/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Passkey_DisabledInputs */

const es_co2_error_passkey_disabled = /** @type {(inputs: Error_Passkey_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta llave está deshabilitada.`)
};

/**

* @param {Error_Passkey_DisabledInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_passkey_disabled = /** @type {((inputs?: Error_Passkey_DisabledInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Passkey_DisabledInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_passkey_disabled(inputs)
});